import {Badge} from "@/components/ui/badge";
import {DetailField} from "@/src/modules/core/components";
import {formatDate, formatTime} from "@/src/modules/core/lib/formatters";

import {
  getCitationStoredVehicleBadgeLabel,
  getCitationStoredVehicleId,
  getCitationStoredVehicleSummary,
} from "../lib/citation-stored-vehicle-origin";
import type {Citation} from "../types";

type Props = {
  citation: Citation;
};

export function CitationStoredVehicleOriginSection({citation}: Props) {
  const storedVehicleId = getCitationStoredVehicleId(citation);
  if (storedVehicleId == null) {
    return null;
  }

  const summary = getCitationStoredVehicleSummary(citation);
  const trackingStarted = summary?.tracking_started_at?.trim();
  const citeEligible = summary?.cite_eligible_at?.trim();

  return (
    <div className="border-border flex flex-col gap-3 border-t pt-4">
      <div className="flex flex-wrap items-center gap-2">
        <p className="text-sm font-medium">Stored vehicle</p>
        <Badge variant="secondary" className="text-xs font-medium">
          Issued from tracking
        </Badge>
      </div>
      <div className="grid gap-x-4 gap-y-3 sm:grid-cols-2">
        <DetailField label="Record">
          {getCitationStoredVehicleBadgeLabel(storedVehicleId)}
        </DetailField>
        {trackingStarted ? (
          <DetailField label="Tracking started">
            {formatDate(trackingStarted)} {formatTime(trackingStarted)}
          </DetailField>
        ) : null}
        {citeEligible ? (
          <DetailField label="Cite eligible">
            {formatDate(citeEligible)} {formatTime(citeEligible)}
          </DetailField>
        ) : null}
      </div>
    </div>
  );
}
